import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { DesktopAndTabletLeftBlock } from './DesktopAndTabletLeftBlock';
import { ProductsDesktopAndTabletCustomSlider as DesktopAndTabletSlider } from './ProductsDesktopAndTabletCustomSlider';
import { TextInfoBlock } from './TextInfoBlock';
import type { ProductGridProps } from './type';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  padding: 0 ${theme.spacing['4x']};
`;

const RightBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopInfoContent = styled.div`
  display: flex;
  /* height: 30%; */
  padding: ${theme.spacing['6x']} ${theme.spacing['8x']};
  border-radius: ${theme.radius.xs};
  background-color: ${theme.colors.primary[400]};
  margin: 0 ${theme.spacing['4x']};
  margin-bottom: ${theme.spacing['4x']};
  margin-right: 0;
`;

type TabletProductsGridProps = ProductGridProps & { setIsOpen: () => void };

export const TabletProductsGrid = ({ textData, cards, setIsOpen }: TabletProductsGridProps) => {
  return (
    <Wrapper>
      <DesktopAndTabletLeftBlock setIsOpen={setIsOpen} textData={textData} />
      <RightBlockWrapper>
        <TopInfoContent>
          <TextInfoBlock color="white" setIsOpen={setIsOpen} textData={textData.infoBlock} />
        </TopInfoContent>
        <DesktopAndTabletSlider cards={cards} />
      </RightBlockWrapper>
    </Wrapper>
  );
};
